<template>
  <div class="container">
    <h1>{{ errorMessage }}</h1>
    <div v-if="errorDetails">
      <h5>Original error:</h5>
      <pre>{{ errorDetails }}</pre>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    errorMessage: {
      type: String,
      required: true,
    },
    errorDetails: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
